import { useUserStore } from 'hooks/stores/useUserStore';
import Router from 'next/router';
import { useEffect } from 'react';

/** The old redirect hook, which may be problematic to use depending on how it is called. (e.g. some usages of it may be inside a useEffect callback, rather than directly on a functional component. This one will eventually be deleted. */
export const useAuthRedirect = (
  redirectPath: string,
  reqOperator?: boolean,
) => {
  const { currentUser, isOperator, userInitialized } = useUserStore();

  if (userInitialized) {
    if (!currentUser || (reqOperator && !isOperator)) {
      Router.push(`/login?redirect=${encodeURIComponent(redirectPath)}`);
      return false;
    }
    return true;
  } else {
    return false;
  }
};

/** An effect that redirects the user to the login page once the user store has been initialised with a user that is not logged in. If the user is already logged in, they are not redirected */
export function useAuthRedirectEffect(
  redirectPath: string,
  reqOperator?: boolean,
): void {
  const { currentUser, isOperator, userInitialized } = useUserStore();

  useEffect(() => {
    if (userInitialized) {
      if (!currentUser || (reqOperator && !isOperator)) {
        Router.push(`/login?redirect=${encodeURIComponent(redirectPath)}`);
      }
    }
  }, [userInitialized, currentUser]);
}
